import { css } from '@emotion/css';

const container = css`
  & > .MuiTypography-h6 {
    color: var(--colors-primary-500);
    font-weight: var(--text-weights-bold);
    margin-bottom: var(--spacings-0);
  }

  & > .MuiTypography-body2 {
    color: var(--colors-neutral-500);
    font-weight: var(--text-weights-semi-bold);
    margin-bottom: var(--spacings-4);
  }
`;

const content = css`
  padding: 0 var(--dimensions-15);

  & > .MuiTypography-root {
    margin-top: var(--spacings-4);
    font-weight: var(--text-weights-semi-bold);
  }

  @media (max-width: 728px) {
    padding: 0;
  }
`;

const buttonAction = css`
  display: flex;
  justify-items: space-between;
  align-items: center;
  gap: var(--spacings-3);
  padding: var(--spacings-3) 0;
  border-bottom: 1px solid var(--colors-neutral-200);

  &:last-child {
    border-bottom: none;
  }

  & > .MuiBox-root {
    display: flex;
    flex-direction: column;
    gap: var(--spacings-0);

    & > .MuiTypography-body2 {
      color: var(--colors-primary-500);
      font-weight: var(--text-weights-semi-bold);
    }

    & > .MuiTypography-caption {
      color: var(--colors-neutral-500);
      font-weight: var(--text-weights-semi-bold);
    }
  }

  & > .MuiButtonBase-root {
    background-color: var(--colors-primary-500);
    color: var(--colors-white);

    &:hover {
      background-color: var(--colors-primary-700);
    }
  }
`;

const accountCreatedStyles = { container, content, buttonAction };

export default accountCreatedStyles;
